import React from "react";
import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Box,
    Button,
    CircularProgress, Grid, IconButton,
    Tooltip,
    Typography,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {getAddresse, getDataInString} from "../RightAccordion";
import IconesRight from "../../pages/compos/IconesRight";
import InfoIcon from "@mui/icons-material/Info";
import IconMaison from "../../ico/IconMagasin";
import LocalParkingIcon from "@mui/icons-material/LocalParking";
import AspectRatioIcon from "@mui/icons-material/AspectRatio";
import HeightIcon from "@mui/icons-material/Height";
import IconEtage2 from "../../ico/IconEtage2";
import IconMSquare2 from "../../ico/IconMSquare2";
import IconMur from "../../ico/IconMur";
import IconToit from "../../ico/IconToit";
import {resBdnb} from "../AttributBdnb";
import FlatBar3 from "../FaltBar3";
import {getDpeColor, getMaxDpeValue} from "../../pages/dpeByIris/MapPage";
import {mergeValuesAndLabels, mergeValuesAndLabelsV1, resDpeV2} from "../AttributDpeV2";
import FlatDpe from "../FaltDpe";

export function surfaceDpe(surf){
     surf = Number(surf);
    if (surf < 40) {
        return "<40m²";
    } else if (surf < 55) {
        return "40 & 55m²";
    } else if (surf < 80) {
        return "55 & 80m²";
    } else if (surf < 110) {
        return "80 & 110m²";
    } else {
        return ">110 m²";
    }
}

export function mergeValuesAndLabelsV2(dpes) {
    let res = {}
    dpes.forEach(dpe => {

        let k=surfaceDpe(dpe["surface_habitable_logement"]);
        if (!res[k]) {
            res[k] = 0;
        }
        res[k]++;
    })


    return Object.keys(res).map(k => ` ${res[k]} : ${k}`).join("<br/>");
}

export default function DpeV2ImmeubleDetails({selectedItem,details}) {
    const [open, setOpen] = React.useState(false);

    React.useEffect(() => {
        if(details){
            setOpen(details);
        }
    },[details]);
    return (<Box> <Box sx={{
            width: "90%",
            borderRadius: "8px",
            backgroundColor: "#f7f9fc",
            padding: 2
        }}>
            <Box sx={{
                display: "flex",
                width: "100%",
                borderColor: "#000",
                borderBottomStyle: "solid",
                height: 30
            }}>
                <Typography>CLASSE DPE</Typography>
            </Box>
            <Box sx={{
                display: "flex",
                width: "100%",
                flexDirection: "column",
            }}
            >

                <Box sx={{
                    display: "flex",
                    width: "100%",
                    flexDirection: "column",
                }}>
                    <Box sx={{
                        display: "flex",
                        borderBottomStyle: "dashed",
                        borderColor: "#505050",
                        borderWidth: "thin",
                        marginTop: 2,
                        marginBottom: 2,
                        alignItems: "center",
                        justifyContent: "flex-start",

                        width: "100%"
                    }}>
                        <Box sx={{width: "60%"}}>
                            <Typography sx={{fontWeight: 300}} variant="body2" display="block"
                                        gutterBottom>Catégorie DPE opposables retenue :
                            </Typography>
                        </Box>
                        <Box sx={{width: "40%"}}>
                            <Box width={{
                                width: 40,
                                height: 20,
                                backgroundColor: getDpeColor(getMaxDpeValue(selectedItem.listOfDpesV2Immeuble,"etiquette_dpe")),
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                borderRadius: 5
                            }}>
                                <Typography sx={{fontWeight: 500}} color={"#000"} variant="body2">
                                    {getMaxDpeValue(selectedItem.listOfDpesV2Immeuble,"etiquette_dpe")}
                                </Typography>
                            </Box>
                        </Box>
                    </Box>
                    <Box sx={{
                        display: "flex",
                        borderColor: "#505050",
                        marginTop: 1,
                        marginBottom: 1,
                        alignItems: "center",
                        justifyContent: "flex-start"
                    }}>
                        <Box sx={{width: "60%"}}>
                            <Typography sx={{fontWeight: 300}} variant="body2" display="block"
                                        gutterBottom>{selectedItem.listOfDpesV2Immeuble.length} DPE réalisés
                            </Typography>
                        </Box>
                        <Box sx={{width: "40%"}}>
                        </Box>
                    </Box>
                    <FlatDpe
                        values={selectedItem.listOfDpesV2Immeuble}
                        labels={["G", "F", "E", "D", "C", "B", "A"]}
                        colors={["#f71e1a", "#f79b40", "#f6c824", "#f7f72b", "#cefc43", "#43ce3f", "#2d682e"]}
                        classe={"etiquette_dpe"}
                    />

                </Box>

                <Box sx={{
                    display: "flex",
                    borderColor: "#505050",
                    marginTop: 1,
                    marginBottom: 1,
                    alignItems: "center",
                    justifyContent: "flex-start"
                }}>
                    <Box sx={{width: "60%"}}>
                        <Typography sx={{fontWeight: 300}} variant="body2" display="block"
                                    gutterBottom>Classe GES
                        </Typography>
                    </Box>
                    <Box sx={{width: "40%"}}>
                    </Box>
                </Box>
                <FlatDpe
                    values={selectedItem.listOfDpesV2Immeuble}
                    labels={["G", "F", "E", "D", "C", "B", "A"]}
                    colors={["#9d13e9", "#b850f4", "#c875f7", "#d697f9",
                        "#deabfa", "#e8c4fc", "#f8eefe"]}
                    classe={"etiquette_ges"}
                />


            </Box>
            <Button onClick={() => {
                setOpen(!open)
            }}>{open && "- détails"}
                {!open && "+ détails"}
            </Button>
        </Box>
            {open && <Box>
                <Box sx={{
                    width: "90%",
                    borderRadius: "8px",
                    backgroundColor: "#f7f9fc",
                    padding: 2,
                    display: "flex",
                    flexDirection: "column",
                    margin: 2,
                    alignItems: "center"
                }}>
                    <Box sx={{
                        display: "flex",
                        width: "100%",
                        borderColor: "#000",
                        borderBottomStyle: "solid",
                        height: 30
                    }}>
                        <Typography>CARACTERISTIQUES GENERALES</Typography>
                    </Box>
                    <Box sx={{
                        display: "flex",
                        width: "100%",
                        borderBottomStyle: "dashed",
                        borderWidth: "thin",
                        borderColor: "#505050",

                    }}
                    >
                        <Box sx={{width: "50%"}}>
                            <Typography color={"#505050"} variant="body2" display="block"
                                        gutterBottom>Type de logement audité</Typography>
                        </Box>
                        <Box sx={{width: "50%"}}>
                            <Typography variant="body2"
                                        gutterBottom dangerouslySetInnerHTML={{
                                __html: mergeValuesAndLabelsV1(selectedItem.listOfDpesV2Immeuble, "methode_application_dpe")
                            }}/>


                        </Box>
                    </Box>
                    <Box sx={{
                        display: "flex",
                        width: "100%",
                        borderBottomStyle: "dashed",
                        borderWidth: "thin",
                        borderColor: "#505050",

                    }}
                    >
                        <Box sx={{width: "50%"}}>
                            <Typography color={"#505050"} variant="body2" display="block"
                                        gutterBottom>Typologie de logements</Typography>
                        </Box>
                        <Box sx={{width: "50%"}}>
                            <Typography variant="body2"
                                        gutterBottom
                                        dangerouslySetInnerHTML={{
                                            __html:
                                                mergeValuesAndLabelsV2(selectedItem.listOfDpesV2Immeuble)
                                        }}
                            />

                        </Box>
                    </Box>
                    <Box sx={{
                        display: "flex",
                        width: "100%",
                        borderBottomStyle: "dashed",
                        borderWidth: "thin",
                        borderColor: "#505050",

                    }}
                    >
                        <Box sx={{width: "50%"}}>
                            <Typography color={"#505050"} variant="body2" display="block"
                                        gutterBottom>Type énergie 1</Typography>
                        </Box>
                        <Box sx={{width: "50%"}}>
                            <Typography variant="body2"
                                        gutterBottom
                                        dangerouslySetInnerHTML={{
                                            __html:
                                                mergeValuesAndLabelsV1(selectedItem.listOfDpesV2Immeuble, "type_energie_n1")
                                        }}/>
                        </Box>
                    </Box>
                </Box>
                <Box sx={{
                    width: "90%",
                    borderRadius: "8px",
                    backgroundColor: "#f7f9fc",
                    padding: 2,
                    display: "flex",
                    flexDirection: "column",
                    margin: 2,
                    alignItems: "center"
                }}>
                    <Box sx={{
                        display: "flex",
                        width: "100%",
                        borderColor: "#000",
                        borderBottomStyle: "solid",
                        height: 30
                    }}>
                        <Typography>CARACTERISTIQUES CHAUFFAGE</Typography>
                    </Box>
                    <Box sx={{
                        display: "flex",
                        width: "100%",
                        borderBottomStyle: "dashed",
                        borderWidth: "thin",
                        borderColor: "#505050",

                    }}
                    >
                        <Box sx={{width: "50%"}}>
                            <Typography color={"#505050"} variant="body2" display="block"
                                        gutterBottom>Type installation chauffage</Typography>
                        </Box>
                        <Box sx={{width: "50%"}}>
                            <Typography variant="body2"
                                        gutterBottom
                                        dangerouslySetInnerHTML={{
                                            __html: mergeValuesAndLabelsV1(selectedItem.listOfDpesV2Immeuble, "type_installation_chauffage","type_installation_chauffage_n1")
                                        }}/>


                        </Box>
                    </Box>
                    <Box sx={{
                        display: "flex",
                        width: "100%",
                        borderBottomStyle: "dashed",
                        borderWidth: "thin",
                        borderColor: "#505050",

                    }}
                    >
                        <Box sx={{width: "50%"}}>
                            <Typography color={"#505050"} variant="body2" display="block"
                                        gutterBottom>Type énergie principale chauffage</Typography>
                        </Box>
                        <Box sx={{width: "50%"}}>
                            <Typography variant="body2"
                                        gutterBottom
                                        dangerouslySetInnerHTML={{
                                            __html:
                                                mergeValuesAndLabelsV1(selectedItem.listOfDpesV2Immeuble, "type_energie_principale_chauffage")
                                        }}/>
                        </Box>
                    </Box>
                    <Box sx={{
                        display: "flex",
                        width: "100%",
                        borderBottomStyle: "dashed",
                        borderWidth: "thin",
                        borderColor: "#505050",

                    }}
                    >
                        <Box sx={{width: "50%"}}>
                            <Typography color={"#505050"} variant="body2" display="block"
                                        gutterBottom>Description générateur chauffage n°1 installation</Typography>
                        </Box>
                        <Box sx={{width: "50%"}}>
                            <Typography variant="body2"
                                        gutterBottom
                                        dangerouslySetInnerHTML={{
                                            __html:
                                                mergeValuesAndLabelsV1(selectedItem.listOfDpesV2Immeuble, "type_generateur_chauffage_principal")
                                        }
                                        }/>

                        </Box>
                    </Box>
                </Box>
                <Box sx={{
                    width: "90%",
                    borderRadius: "8px",
                    backgroundColor: "#f7f9fc",
                    padding: 2,
                    display: "flex",
                    flexDirection: "column",
                    margin: 2,
                    alignItems: "center"

                }}>
                    <Box sx={{
                        display: "flex",
                        width: "100%",
                        borderColor: "#000",
                        borderBottomStyle: "solid",
                        height: 30
                    }}>
                        <Typography>CARACTERISTIQUES EAU CHAUDE SANITARIES (ECS)</Typography>
                    </Box>
                    <Box sx={{
                        display: "flex",
                        width: "100%",
                        borderBottomStyle: "dashed",
                        borderWidth: "thin",
                        borderColor: "#505050",

                    }}
                    >
                        <Box sx={{width: "50%"}}>
                            <Typography color={"#505050"} variant="body2" display="block"
                                        gutterBottom>Type d'installation ECS (général)</Typography>
                        </Box>
                        <Box sx={{width: "50%"}}>
                            <Typography variant="body2"
                                        gutterBottom
                                        dangerouslySetInnerHTML={{
                                            __html:
                                                mergeValuesAndLabelsV1(selectedItem.listOfDpesV2Immeuble, "type_installation_ecs","type_installation_ecs_n1")
                                        }}/>
                        </Box>

                    </Box>

                    <Box sx={{
                        display: "flex",
                        width: "100%",
                        borderBottomStyle: "dashed",
                        borderWidth: "thin",
                        borderColor: "#505050",

                    }}
                    >
                        <Box sx={{width: "50%"}}>
                            <Typography color={"#505050"} variant="body2" display="block"
                                        gutterBottom>Type d'énergie principale ECS
                            </Typography>
                        </Box>
                        <Box sx={{width: "50%"}}>
                            <Typography variant="body2"
                                        gutterBottom
                                        dangerouslySetInnerHTML={{
                                            __html:
                                                mergeValuesAndLabelsV1(selectedItem.listOfDpesV2Immeuble, "type_energie_principale_ecs")
                                        }}
                            />
                        </Box>

                    </Box>
                    <Box sx={{
                        display: "flex",
                        width: "100%",
                        borderBottomStyle: "dashed",
                        borderWidth: "thin",
                        borderColor: "#505050",

                    }}
                    >
                        <Box sx={{width: "50%"}}>
                            <Typography color={"#505050"} variant="body2" display="block"
                                        gutterBottom>Description générateur ECS n°1
                            </Typography>
                        </Box>
                        <Box sx={{width: "50%"}}>
                            <Typography variant="body2"
                                        gutterBottom
                                        dangerouslySetInnerHTML={{
                                            __html:

                                                mergeValuesAndLabelsV1(selectedItem.listOfDpesV2Immeuble, "type_generateur_chauffage_principal_ecs")
                                        }
                                        }/>

                        </Box>

                    </Box>
                </Box>
                <Box sx={{
                    width: "90%",
                    borderRadius: "8px",
                    backgroundColor: "#f7f9fc",
                    padding: 2,
                    display: "flex",
                    flexDirection: "column",
                    margin: 2,
                    alignItems: "center"
                }}>
                    <Box sx={{
                        display: "flex",
                        width: "100%",
                        borderColor: "#000",
                        borderBottomStyle: "solid",
                        height: 30
                    }}>
                        <Typography>CARACTERISTIQUES BATIMENT</Typography>
                    </Box>
                    <Box sx={{
                        display: "flex",
                        width: "100%",
                        flexDirection: "column",
                    }}
                    >
                        <Box sx={{width: "100%", display: "flex"}}>
                            <Box sx={{
                                width: "100%",
                                display: "flex",
                                flexDirection: "column",
                                overflow: "hidden"
                            }}>
                                <Typography variant="body2">Classe inertie bâtiment</Typography>
                                <FlatBar3
                                    values={selectedItem.listOfDpesV2Immeuble}
                                    colors={["#eb7a73", "#efbd8c", "#efbd8c", "#DFDFDF",
                                        "#f7f891", "#F0F0F0", "#9bdb8c"]}
                                    textColor={"#fff"}
                                    classe={"classe_inertie_batiment"}
                                />

                            </Box>
                        </Box>
                        <Box sx={{width: "100%", display: "flex"}}>
                            <Box sx={{
                                width: "100%",
                                display: "flex",
                                flexDirection: "column",
                                overflow: "hidden"
                            }}>
                                <Typography variant="body2">Qualité isolation enveloppe</Typography>
                                <FlatBar3
                                    values={selectedItem.listOfDpesV2Immeuble}
                                    colors={["#eb7a73", "#efbd8c", "#efbd8c", "#DFDFDF",
                                        "#f7f891", "#F0F0F0", "#9bdb8c"]}
                                    textColor={"#fff"}
                                    classe={"qualite_isolation_enveloppe"}
                                />
                            </Box>
                        </Box>
                        <Box sx={{width: "100%", display: "flex"}}>
                            <Box sx={{
                                width: "100%",
                                display: "flex",
                                flexDirection: "column",
                                overflow: "hidden"
                            }}>
                                <Typography variant="body2">Qualité isolation menuiseries</Typography>

                                <FlatBar3
                                    values={selectedItem.listOfDpesV2Immeuble}
                                    colors={["#eb7a73", "#efbd8c", "#efbd8c", "#DFDFDF",
                                        "#f7f891", "#F0F0F0", "#9bdb8c"]}
                                    textColor={"#fff"}
                                    classe={"qualite_isolation_menuiseries"}
                                />
                            </Box>
                        </Box>
                        <Box sx={{width: "100%", display: "flex"}}>
                            <Box sx={{
                                width: "100%",
                                display: "flex",
                                flexDirection: "column",
                                overflow: "hidden"
                            }}>
                                <Typography variant="body2">Qualité isolation murs</Typography>

                                <FlatBar3
                                    values={selectedItem.listOfDpesV2Immeuble}
                                    colors={["#eb7a73", "#efbd8c", "#efbd8c", "#DFDFDF",
                                        "#f7f891", "#F0F0F0", "#9bdb8c"]}
                                    textColor={"#fff"}
                                    classe={"qualite_isolation_murs"}
                                />


                            </Box>
                        </Box>
                    </Box>
                </Box>
            </Box>}
        </Box>
    )
}

